export default __webpack_public_path__ + "static/media/Skup Pula (8).4d6cb35e.jpg";